var isEmptyObject = function isEmptyObject(obj) {
  // eslint-disable-next-line no-restricted-syntax, guard-for-in, no-underscore-dangle
  for (var _key in obj) return false;
  return true;
};

export { isEmptyObject };
//# sourceMappingURL=isEmptyObject.js.map
